import {showMessage} from 'react-native-flash-message';

const TONES = {
  good: {accent: '#C5E836', border: 'rgba(197,232,54,0.55)'},
  neutral: {accent: '#F6FBFF', border: 'rgba(255,255,255,0.18)'},
  danger: {accent: '#FCA5A5', border: 'rgba(248,113,113,0.55)'},
};

/**
 * Plan and purchase notices in the world, styled like the plans screen - a floating dark card with a
 * coloured title - instead of the library's full-width coloured bar (owner 2026-09-29: "the notification
 * design is too out of style").
 */
export const showWorldNotice = ({title, description, tone = 'neutral', duration = 6000}) => {
  const {accent, border} = TONES[tone] || TONES.neutral;
  showMessage({
    message: title,
    description,
    duration,
    floating: true,
    backgroundColor: '#10151F',
    color: '#F6FBFF',
    style: {
      alignSelf: 'center',
      minWidth: 320,
      maxWidth: 460,
      marginTop: 12,
      paddingVertical: 12,
      paddingHorizontal: 18,
      borderRadius: 14,
      borderWidth: 1,
      borderColor: border,
    },
    titleStyle: {color: accent, fontSize: 15, fontWeight: '800'},
    textStyle: {marginTop: 2, color: 'rgba(246,251,255,0.75)', fontSize: 13},
  });
};
